<script>
    import ProgressBarItem from './ProgressBarItem.svelte';
    export let progress, step;
</script>

<div class="progress-steps-holder" data-active-step={step}>
    <div class="progress-steps">
        <ProgressBarItem
            stepIndex="1"
            stepText="Personaliza"
            href="/compra/configura"
            currentStep={step}
        />
        <ProgressBarItem
            stepIndex="2"
            stepText="Datos de cuenta"
            href="/compra/datos"
            currentStep={step}
        />
        <ProgressBarItem
            stepIndex="3"
            stepText="Método de instalación"
            href="/compra/direccion"
            currentStep={step}
        />
        <ProgressBarItem
            stepIndex="4"
            stepText="Resumen"
            href="/compra/resumen"
            currentStep={step}
        />
        <ProgressBarItem
            stepIndex="5"
            stepText="Pago"
            href="/compra/pago"
            currentStep={step}
        />
    </div>
    <div class="progress-bar-holder">
        <div class="progress-bar"></div>
        <div class="progress-indicator" style="width: {progress}%"></div>
    </div>
</div>
